export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const FRONT_END_BASE_URL = process.env.REACT_APP_FRONT_END_BASE_URL;
